import { useEffect, useState } from 'react';

/** Default refresh cadence for time-derived UI (stale delay signals, relative labels). */
export const DEFAULT_NOW_TICK_INTERVAL_MS = 60 * 1000;

/**
 * Returns the current epoch ms, refreshed on a fixed interval.
 * Drives time-derived values without re-rendering on unrelated data events.
 */
export const useNowTicker = (
  intervalMs: number = DEFAULT_NOW_TICK_INTERVAL_MS,
): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
};

export default useNowTicker;
